/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Share_Error_Groups_RequiredInputs */



/**
* | output |
* | --- |
* | "Share must include at least one event group." |
*
* @param {Team_Share_Error_Groups_RequiredInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_error_groups_required = /** @type {((inputs?: Team_Share_Error_Groups_RequiredInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_Error_Groups_RequiredInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Le partage doit inclure au moins un groupe d’événements.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Der Beitrag muss mindestens eine Veranstaltungsgruppe enthalten.")
	if (locale === "it") return /** @type {LocalizedString} */ ("La condivisione deve includere almeno un gruppo di eventi.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("В состав публикации должна входить как минимум одна группа событий.")
	if (locale === "es") return /** @type {LocalizedString} */ ("La acción debe incluir al menos un grupo de eventos.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("分享内容必须至少包含一个活动组。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("共有には少なくとも 1 つのイベント グループを含める必要があります。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("शेयर में कम से कम एक इवेंट ग्रुप शामिल होना चाहिए।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("O compartilhamento deve incluir pelo menos um grupo de eventos.")
	return /** @type {LocalizedString} */ ("Share must include at least one event group.")
});